import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFirebase from "../../../../../useFirebase";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import { setShowMessage, setErrorInfo } from "../../../AxiosRtk/successMessage";
import { videoNudityMonitor } from "../../../AxiosRtk/SetRules";
import { useHistory } from "react-router-dom";

const SocialMedia = ({ deviceSelected, getLangTranslation }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { AdminSetRuleLanguageData, setRulesData } = useSelector(
    ({ setRules }) => setRules
  );
  const { selectedKidId } = useSelector(({ dashboard }) => dashboard);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang = AdminSetRuleLanguageData?.languages?.find(
    (item) => item?.id === appLanguageId
  );
  const [normalFormattedAllowedApps, setNormalFormattedAllowedApps] = useState(
    []
  );
  const [socialAppData, setSocialAppData] = useState([]);
  
  const [socialMediaData, setSocialMediaData] = useState({
    enableSocialMediaCommunicationMonitoring: false,
    enableTickTokHistoryMonitoring: false,
    enableThreatDetectionOnSocialMediaMonitoring: false,
  });

  const { getCollectionData, postCollectionData, createCollectionData } =
    useFirebase();

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }

    getCollectionData("AdminSetRuleData", "socialApps")
      .then((res) => {
        setSocialAppData(res?.apps ?? []);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [deviceSelected]);

  useEffect(() => {
    if (setRulesData) {
      const tempAllowedApps = setRulesData?.timesupervison?.allowedApps?.length > 0 ? (
        setRulesData?.timesupervison?.allowedApps
      )?.filter(
        (item) =>
          socialAppData?.find(
            (sadItem) => sadItem?.package === item?.appPackageName
          )
      ) : socialAppData;

      setNormalFormattedAllowedApps(tempAllowedApps);
    } else {
      setNormalFormattedAllowedApps([]);
    }
  }, [setRulesData, socialAppData]);

  useEffect(() => {
    if (setRulesData) {
      const enableSocialMediaCommunicationMonitoring =
        setRulesData?.socialmediacommunication
          ?.enableSocialMediaCommunicationMonitoring;
      const enableTickTokHistoryMonitoring =
        setRulesData?.socialmediacommunication?.enableTickTokHistoryMonitoring;
      const enableThreatDetectionOnSocialMediaMonitoring =
        setRulesData?.socialmediacommunication
          ?.enableThreatDetectionOnSocialMediaMonitoring;

      setSocialMediaData({
        enableSocialMediaCommunicationMonitoring,
        enableThreatDetectionOnSocialMediaMonitoring,
        enableTickTokHistoryMonitoring,
      });
    }
  }, [setRulesData]);

  function callFirebase(payload) {
    const newPayload = {
      timesupervison: {
        ...setRulesData?.timesupervison,
        allowedApps: normalFormattedAllowedApps,
      },
      setRulesActiveInActiveStatus: {
        ...setRulesData?.setRulesActiveInActiveStatus,
        socialMediaCommunications:
          payload?.enableSocialMediaCommunicationMonitoring,
      },
      socialmediacommunication: payload,
    };

    if (setRulesData) {
      postCollectionData(deviceSelected, newPayload);
    } else {
      createCollectionData(deviceSelected, newPayload);
    }
    getCollectionData(deviceSelected);

    setTimeout(() => {
      dispatch(
        setShowMessage({
          showMessage: true,
          message: "KEYSTROKE_STATUS_UPDATED",
          defaultMessage: "Changes successfully updated",
        })
      );
    }, 1000);
  }

  function handleSaveAllChanges() {
    if (!deviceSelected) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "DEVICE_NOT_SELECTED",
          defaultTitle: "Device not selected",
        })
      );
      return;
    }

    const collectionPayload = {
      ...setRulesData?.socialmediacommunication,
      enableThreatDetectionOnSocialMediaMonitoring:
        socialMediaData?.enableThreatDetectionOnSocialMediaMonitoring,
      enableTickTokHistoryMonitoring:
        socialMediaData?.enableTickTokHistoryMonitoring,
    };

    const dbPayload = {
      deviceId: deviceSelected,
      kidId: selectedKidId,
      smart_text_detection:
        socialMediaData?.enableThreatDetectionOnSocialMediaMonitoring ? 1 : 0,
      tiktok_monitoring:
        socialMediaData?.enableThreatDetectionOnSocialMediaMonitoring ? 1 : 0,
    };

    callFirebase(collectionPayload);

    videoNudityMonitor(dbPayload)
      .then((res) => { })
      .catch((err) => {
        console.log(
          "video nudity monitory catch error ==>>",
          err?.response?.data?.message
        );
      });
  }

  function handleSocialMediaActivate(checkedStatus) {
    if (!deviceSelected) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "DEVICE_NOT_SELECTED",
          defaultTitle: "Device not selected",
        })
      );
      return;
    }

    const collectionPayload = {
      ...setRulesData?.socialmediacommunication,
      enableSocialMediaCommunicationMonitoring: checkedStatus,
      enableThreatDetectionOnSocialMediaMonitoring: false,
      enableTickTokHistoryMonitoring: false,
    };

    const dbPayload = {
      deviceId: deviceSelected,
      kidId: selectedKidId,
      social_media_communication: checkedStatus ? 1 : 0,
      smart_text_detection: 0,
      tiktok_monitoring: socialMediaData?.enableTickTokHistoryMonitoring
        ? 1
        : 0,
    };

    callFirebase(collectionPayload);

    videoNudityMonitor(dbPayload)
      .then((res) => { })
      .catch((err) => {
        console.log(
          "video nudity monitory catch error ==>>",
          err?.response?.data?.message
        );
      });

  }

  function handleScreenShotSelect(e) {
    const { name, checked } = e.target;
    let tempAllowedApps = [...normalFormattedAllowedApps];

    const indexToModified = tempAllowedApps?.findIndex(
      (item, index) => parseInt(item?.appUuid) === parseInt(name)
    );
    const gettingModifiableObj = { ...tempAllowedApps[indexToModified] };
    gettingModifiableObj["socialMediaCommunicationStatus"] = checked
      ? true
      : false;

    tempAllowedApps.splice(indexToModified, 1, gettingModifiableObj);

    setNormalFormattedAllowedApps(tempAllowedApps);
  }

  return (
    <>
      <div
        className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
        role="alert"
      >
        <i className="icon-info-one fs-5" />
        {getLangTranslation(
          "SOCIAL_MEDIA_COMMUNICATION_PAGE_TITLE",
          "By enabling this feature, you will be able to monitor and read content of social media communications"
        )}
        {/* <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button> */}
      </div>
      <div className="w-100">
        <div>
          <div className="d-flex justify-content-between w-100">
            <div className="form-check form-switch me-auto mb-6 pt-4">
              <input
                className="form-check-input"
                id="activateScreenshot"
                type="checkbox"
                role="switch"
                checked={
                  socialMediaData?.enableSocialMediaCommunicationMonitoring ??
                  false
                }
                onChange={(e) => handleSocialMediaActivate(e.target.checked)}
              />
              <label
                className="form-check-label text-blue-800 fw-semibold"
                htmlFor="activateScreenshot"
              >
                {getLangTranslation(
                  "SOCIAL_MEDIA_COMMUNICATION_ACTIVATE",
                  "Activate"
                )}
              </label>
            </div>
            <div className="mb-6">
              {" "}
              {socialMediaData?.enableSocialMediaCommunicationMonitoring && (
                <div className="d-flex align-items-center flex-wrap gap-3">
                  {/*<button
								  className="btn btn-outline-primary d-inline-flex align-items-center gap-1 "
								  onClick={() => history.push("/social-media-select-apps")}
							  >
								  <i className="icon-plus fs-5" />
								  <span className="btn-upper-case">
									  {getLangTranslation("SOCIAL_MEDIA_COMMUNICATION_SELECT_APPS", "SELECT APPS")}
								  </span>
					  </button>*/}
                  <button
                    className="btn btn-primary"
                    onClick={() => handleSaveAllChanges()}
                  >
                    <span className="btn-upper-case">
                      {getLangTranslation("SAVE", "Save")}
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="card m-3 p-3 social-apps">
            {normalFormattedAllowedApps?.map((item, index) => {
              return (
                <div className="form-check form-switch form-check-right mb-4">
                  <label
                    className="form-check-label d-inline-flex align-items-center"
                    htmlFor={item?.appUuid}
                  >
                    <span className="icon-wrap icon-sm me-2 p-0">
                      <img src={item?.image} alt="avatar" />
                    </span>
                    {item?.app_name}
                  </label>

                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={item?.appUuid}
                    name={item?.appUuid}
                    checked={item["socialMediaCommunicationStatus"]}
                    onChange={handleScreenShotSelect}
                  />
                </div>
              );
            })}
          </div>
          {/* enableTickTokHistoryMonitoring */}
          {socialMediaData?.enableSocialMediaCommunicationMonitoring && (
            <>
              <div className="form-check form-switch me-auto mb-2">
                <input
                  className="form-check-input"
                  id="enableSmart"
                  type="checkbox"
                  role="switch"
                  checked={
                    socialMediaData?.enableTickTokHistoryMonitoring ?? false
                  }
                  onChange={(e) =>
                    setSocialMediaData({
                      ...socialMediaData,
                      enableTickTokHistoryMonitoring: e.target.checked,
                    })
                  }
                />
                <label className="form-check-label" htmlFor="enableSmart">
                  <span className="text-dark">
                    {getLangTranslation(
                      "SOCIAL_MEDIA_COMMUNICATION_ENABLE_TICTOK_HISTORY_MONITORING_TITLE",
                      "Enable TikTok history monitoring"
                    )}
                  </span>
                </label>
                <p className="text-small mb-0">
                  {getLangTranslation(
                    "SOCIAL_MEDIA_COMMUNICATION_ENABLE_TICTOK_HISTORY_MONITORING_DESCRIPTION",
                    "Enable this feature to monitor Tik Tok app logs on kids device"
                  )}
                </p>
              </div>

              <div className="form-check form-switch me-auto mb-2">
                <input
                  className="form-check-input"
                  id="enableSmart"
                  type="checkbox"
                  role="switch"
                  checked={
                    socialMediaData?.enableThreatDetectionOnSocialMediaMonitoring ??
                    false
                  }
                  onChange={(e) =>
                    setSocialMediaData({
                      ...socialMediaData,
                      enableThreatDetectionOnSocialMediaMonitoring:
                        e.target.checked,
                    })
                  }
                />
                <label className="form-check-label" htmlFor="enableSmart">
                  <span className="text-dark">
                    {getLangTranslation(
                      "SOCIAL_MEDIA_COMMUNICATION_ENABLE_SMART_THREAT_THREAD_DETECTION_ON_SOCIAL_MEDIA_TITLE",
                      "Enable smart threat detection on social media communications"
                    )}
                  </span>
                </label>
                <p className="text-small mb-0">
                  {getLangTranslation(
                    "SOCIAL_MEDIA_COMMUNICATION_ENABLE_SMART_THREAT_THREAD_DETECTION_ON_SOCIAL_MEDIA_DESCRIPTION",
                    "This option will allow you to have alerts when our app analyze and detect any threat on the communications on selected apps"
                  )}
                </p>
                
              </div>
              <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
                <i className='icon-info-one fs-5' />
                {getLangTranslation("SOCIAL_MEDIA_THREAT_DETECT_DISCLAIMER", "Our text detection is a good tool. However, be aware of the results. In some cases the result shown is incorrect. it is only for reference.")}
                {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> */}
              </div>

            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SocialMedia;
